<kendo-grid
  #kendoGrid
  [data]="gridWrapper.gridData"
  [loading]="gridWrapper.loading"
  [height]="(bodyHeight$ | async) || 400"
  scrollable="virtual"
  rowHeight="54px"
  [skip]="gridWrapper.gridState.skip"
  [pageSize]="gridWrapper.gridState.take"
  kendoGridSelectBy="id"
  [selectedKeys]="gridWrapper.mySelection"
  [sortable]="true"
  [groupable]="true"
  [group]="gridWrapper.gridState.group"
  [sort]="gridWrapper.gridState.sort"
  (groupChange)="gridWrapper.groupChanged($event)"
  (dataStateChange)="gridWrapper.onDataStateChange($event)"
  [reorderable]="true"
  [resizable]="true"
  filterable="menu"
>
  <kendo-grid-messages
    [noRecords]="gridWrapper.loading ? '' : 'Aucun résultat'"
    filterClearButton="Effacer"
    filterFilterButton="Filtrer"
    groupPanelEmpty="Déplacer ici l'entête d'une colonne pour grouper..."
  >
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <input #mainFilter placeholder="Rechercher..." kendoTextBox (input)="gridWrapper.onFilter($event.target)" />
    <button
      mat-icon-button
      color="primary"
      [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
      (click)="mainFilter.value = ''; gridWrapper.clearFilter()"
    >
      <mat-icon>clear</mat-icon>
    </button>

    <button mat-icon-button color="primary" (click)="reload()" matTooltip="Rafraîchir les données" class="refresh-button">
      <mat-icon>refresh</mat-icon>
    </button>
  </ng-template>

  <kendo-grid-column field="dateHeure" title="Date" filter="date" format="{0:dd.MM.yyyy HH:mm}"> </kendo-grid-column>
  <kendo-grid-column field="utilisateur" title="Utilisateur" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="nomSousSysteme" title="Origine" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="descriptionNiveauLog" title="Niveau de log">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <app-multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="distinctPrimitive(column.field)"
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="message" title="Message" filterable="false"> </kendo-grid-column>
</kendo-grid>
